import { render, staticRenderFns } from "./ListStats.vue?vue&type=template&id=1503bb92&"
import script from "./ListStats.vue?vue&type=script&lang=js&"
export * from "./ListStats.vue?vue&type=script&lang=js&"
import style0 from "./ListStats.vue?vue&type=style&index=0&id=1503bb92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports